import React, { FC, useMemo } from 'react';
import PostCommunication from 'app/modules/posts/modules/post/components/PostCommunication';
import { usePostComposer } from './PostComposerProvider';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';

type Props = {
  accordionProps?: Partial<React.ComponentProps<typeof AccordionWidget>>;
};

const PostComposerCommunication: FC<Props> = ({ accordionProps }) => {
  const { form } = usePostComposer();

  return useMemo(
    () => (
      <>
        {form.id && (
          <PostCommunication
            dataName="post-composer_communication"
            postId={form.id}
            accordionProps={accordionProps}
          />
        )}
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form.id, accordionProps],
  );
};
export default PostComposerCommunication;
